module.exports = __webpack_public_path__ + "static/img/200119.89b95bd5.png";